import { Grid } from "lucide-react";
import { cn } from "@/lib/utils";

interface CategoryIconProps {
  value?: string | null;
  className?: string;
  fallbackClassName?: string;
}

export function CategoryIcon({ value, className, fallbackClassName }: CategoryIconProps) {
  const icon = value?.trim();
  if (!icon) return <Grid className={cn("w-4 h-4", fallbackClassName)} />;

  if (isSafeInlineSvg(icon)) {
    return (
      <span
        aria-hidden
        className={cn("inline-flex items-center justify-center [&>svg]:h-full [&>svg]:w-full", className)}
        dangerouslySetInnerHTML={{ __html: icon }}
      />
    );
  }

  return <span aria-hidden className={className}>{icon}</span>;
}

function isSafeInlineSvg(value: string): boolean {
  if (!/^<svg[\s>]/i.test(value)) return false;
  if (!/<\/svg>\s*$/i.test(value)) return false;
  if (value.length > 4000) return false;
  if (/<(?:script|foreignObject|iframe|object|embed)\b/i.test(value)) return false;
  if (/\bon[a-z]+\s*=/i.test(value)) return false;
  if (/javascript\s*:/i.test(value)) return false;
  if (/data\s*:\s*text\/html/i.test(value)) return false;
  return true;
}
